import i18n from "@/plugins/i18n";

const state = {
  userRole: sessionStorage.userRole ?? "",
  snackbarMessage: "",
};

const getters = {};

const actions = {
  setSnackbarMessageForUserRole(context) {
    context.commit("setSnackbarMessage", context.state.userRole === "CON" ? i18n.tc("landing.reminderForCON.content") : "");
  },
};

const mutations = {
  setUserRole(state, role) {
    sessionStorage.userRole = role ?? "";
    state.userRole = role ?? "";
  },
  setSnackbarMessage(state, msg) {
    state.snackbarMessage = msg ?? "";
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
